export const theme = {
  colors: {
    primary: "#3182ce",
    primaryDark: "#2c5282",
    secondary: "#718096",
    background: "#f7fafc",
    white: "#ffffff",
    text: "#2d3748",
    error: "#c53030",
    success: "#2f855a",
    warning: "#c05621",
    border: "#e2e8f0",
  },
  breakpoints: {
    mobileS: "320px",
    mobileM: "375px",
    mobileL: "425px",
    tablet: "768px",
    laptop: "1024px",
    desktop: "1440px",
    tv: "2560px",
  },
  shadows: {
    tile: "0 4px 6px rgba(0, 0, 0, 0.05)",
    hover: "0 10px 20px rgba(0, 0, 0, 0.1)",
  },
};
